module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinLexiconEntryNotFound":{"entry_not_found_text":"Leider wurde der Eintrag nicht gefunden."}},"en":{"FinLexiconEntryNotFound":{"entry_not_found_text":"The entry was not found."}}}')
  delete Component.options._Ctor
}
